import { render, staticRenderFns } from "./NexiPurchaseForm.vue?vue&type=template&id=31465915&scoped=true"
import script from "./NexiPurchaseForm.vue?vue&type=script&lang=ts"
export * from "./NexiPurchaseForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31465915",
  null
  
)

export default component.exports